<template>
  <div
    class="stays-group__conditions mt-n4"
    :data-testid="'stays-group-conditions-' + localGroup.title"
  >
    <StayCondition
      v-if="localGroup.payAtProperty()"
      class="stays-group__condition"
      classIcon="icon-check color-grass"
      color="grass"
      :label="translate('rdIsPayUponArrival')"
    />
    <StayCondition
      v-if="localGroup.creditCardNotNeeded()"
      class="stays-group__condition"
      classIcon="icon-check color-grass"
      color="grass"
      :label="translate('rdNoCreditCardNeeded')"
    />
    <StayCondition
      v-if="localGroup.freeCancellation()"
      class="stays-group__condition"
      classIcon="icon-check color-grass"
      color="grass"
      :label="
        translate('rdFreeCancellationBefore', undefined, localGroup.getFreeCancellationUpTo())
      "
    />
    <div>
      <div
        v-if="localGroup.selectedStay.conditions.includes('NO_REFUNDABLE') && isRefundable"
        class="mr-3 ml-2 mb-2"
      >
        <i class="mr-1 xs icon-check color-grass"></i>
        <span class="text-14">
          {{ tooltip.description }}
        </span>
        <i class="ml-1 icon-info-2 xs" :id="`popover-target-${_uid}`"></i>
        <b-popover
          custom-class="popover-rates-newRD"
          :target="`popover-target-${_uid}`"
          triggers="hover"
          placement="bottom"
        >
          <span class="text-rich" v-html="tooltip.toolTips[0]"></span>
        </b-popover>
      </div>
    </div>
    <StayCondition
      v-if="localGroup.selectedStay.redeemable"
      class="mb-2"
      classIcon="icon-check color-purple"
      color="black"
      :label="translate('rdPayWithPoints')"
    />
    <StayCondition
      v-if="localGroup.selectedStay.conditions.includes('NO_REFUNDABLE')"
      class="stays-group__condition"
      classIcon="xs icon-cross custom-cross text-12 color-primary"
      :label="translate('rdNoRefundable')"
    />
    <StayCondition
      v-if="isTierVip && isRoomOnly"
      class="stays-group__condition"
      classIcon="sm rhg-font-icon--coffee-tea-facilities vip"
      :label="translate('boVipFreeVipBreakfast')"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import StayCondition from '@/multi-room-display/components/stay/StayCondition'
const { mapGetters } = createNamespacedHelpers('multiRoomDisplay')

export default {
  name: 'rateConditions',
  components: {
    StayCondition
  },
  data: () => ({}),
  props: {
    localGroup: Object,
    isRefundable: Boolean,
    tooltip: Object,
    isRoomOnly: Boolean
  },
  computed: {
    ...mapGetters(['hotel']),
    isTierVip() {
      return this.hotel.freeUpgradeBB
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.vip) {
  color: #382246;
}
html[dir='rtl'] {
  .stays-group {
    &__conditions {
      text-align: right;
    }
  }
}
</style>
